import * as React from 'react';
import { Rutube } from './Rutube';
import * as styles from './styles.css';
import { VKVideo } from './VKVideo';
import { YouTube } from './YouTube';
import { TVideoType } from '../../types/video';

export interface IVideoPlayerProps {
  preview: React.ReactElement<unknown>;
  isCurrent?: boolean;
  type: TVideoType;
  src: string;
}

export const VideoPlayer = ({ preview, isCurrent, src, type }: IVideoPlayerProps) => {
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    if (!isCurrent) {
      setIsActive(false);
    }
  }, [isCurrent]);

  const handlePreviewClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    setIsActive(true);
  };

  if (!isActive) {
    return (
      <div className={styles['container']} data-testid="VideoPlayer">
        <div className={styles['preview']} onClick={handlePreviewClick}>
          {preview}
        </div>
      </div>
    );
  }

  return (
    <div className={styles['container']} data-testid="VideoPlayer">
      {type === 'youtube' && <YouTube src={src} />}
      {type === 'vk' && <VKVideo src={src} />}
      {type === 'rutube' && <Rutube src={src} />}
    </div>
  );
};
